import { render } from "./ReferenceUsersReport.vue?vue&type=template&id=a0b5c8fa&scoped=true"
import script from "./ReferenceUsersReport.vue?vue&type=script&lang=js"
export * from "./ReferenceUsersReport.vue?vue&type=script&lang=js"

import "./ReferenceUsersReport.vue?vue&type=style&index=0&id=a0b5c8fa&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b5c8fa"]])

export default __exports__